import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';

const PageHeader = ({
    header,
}) => (
    <Typography gutterBottom variant="h5" component="h2">
        {header}
    </Typography>
);

PageHeader.propTypes = {
    header: PropTypes.string.isRequired,
};

export default PageHeader;
